import React, { useState, useEffect } from "react";
import "react-datepicker/dist/react-datepicker.css";
import axios from "axios";
import DatePickerField from "../../Components/DatePickerField";
import TextInputField from "../../Components/TextInputField";
import "../Pages.css";
import SelectList from "../../Components/Select";
import { callAPI } from "../../utils/callAPI";
import { apiEndPoints } from "../../constants/apiEndPoints";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const FormQualityDevelopment = (props) => {
  const initialProjectData = {
    departmentName: "",
    azureProjectName: "",
    // monthCycle: "",
    // year: new Date(),
    monthCycle: { value: "Oct-Dec", label: "Oct-Dec" },
    year: new Date(2023, 0, 1),
    security: "",
    performance: "",
    bugsPerHour: "",
    defectDensity: "",
    reviewerComment: "",
  };
  const [projectData, setProjectData] = useState(initialProjectData);
  const [loading, setLoading] = useState(false);
  const [masterData, setMasterData] = useState([]);
  const [projectList, setProjectList] = useState([]);
  const [showValidation, setShowValidation] = useState({
    departmentNameError: null,
    azureProjectNameError: null,
    // monthCycleError: null,
    securityError: null,
    performanceError: null,
    bugsPerHourError: null,
    defectDensityError: null,
    reviewerCommentError: null,
  });

  useEffect(() => {
    const getDepartments = async () => {
      try {
        const allData = await axios.all([
          callAPI("GET", apiEndPoints.getDeptName),
        ]);
        if (allData && allData.length > 0) {
          const departments = allData[0].data.data;
          departments.forEach((item) => {
            item.value = item.departmentId;
            item.label = item.departmentName;
            delete item.departmentId;
            delete item.departmentName;
          });
          setMasterData({
            ...{ departments },
          });
        }
      } catch (error) {}
    };
    getDepartments();
  }, []);

  useEffect(() => {
    const getProjects = async () => {
      let projectList = [];
      if (projectData.departmentName) {
        const departmentName = projectData.departmentName.label;
        try {
          const resp = await callAPI(
            "GET",
            apiEndPoints.getProjName + "?departmentName=" + departmentName
          );
          projectList = resp.data.data;
          projectList.forEach((item) => {
            item.value = item.azureProjectId;
            item.label = item.azureProjectName;
            delete item.azureProjectId;
            delete item.project;
            delete item.department;
          });
        } catch (err) {
          console.log("Error in fetching Project Names: ", err);
        }
      }
      setProjectList(projectList);
    };
    getProjects();
  }, [projectData.departmentName]);

  useEffect(() => {
    props.fetchQualityDevelopment();
  }, []);

  useEffect(() => {
    const fetchBPHourAndDD = async () => {
      const { azureProjectName, monthCycle, year } = projectData;
      try {
        setLoading(true);
        const bugsPerHourResponse = await axios.post(
          `${apiEndPoints.getBugsPerHour}?AzureProjectId=${
            azureProjectName.value
          }&quarter=${monthCycle.value}&year=${year.getFullYear()}`
        );
        const bugDetails = bugsPerHourResponse.data.bugDetails;
        if (bugDetails) {
          setProjectData((prevData) => ({
            ...prevData,
            bugsPerHour: bugDetails.bugsPerHour,
          }));
          setShowValidation((previousData) => ({
            ...previousData,
            bugsPerHourError: false,
          }));
          setProjectData((prevData) => ({
            ...prevData,
            defectDensity: bugDetails.defectDensity,
            reviewerComment: `${bugDetails.bugCount} Bugs Posted, ${bugDetails.totalHours} Hours Of Development`,
          }));
          setShowValidation((previousData) => ({
            ...previousData,
            defectDensityError: false,
            reviewerCommentError: false,
          }));

          const defectDensityResp = await axios.post(
            `${apiEndPoints.getDefectDensity}?bugsPerHour=${bugDetails.bugsPerHour}`
          );

          const defectDensityData = defectDensityResp.data;
          setProjectData((prevData) => ({
            ...prevData,
            defectDensity: defectDensityData.defectDensity,
          }));
          setShowValidation((previousData) => ({
            ...previousData,
            defectDensityError: false,
          }));
        }
      } catch (error) {
      } finally {
        setLoading(false);
      }
    };
    if (
      projectData.azureProjectName &&
      projectData.monthCycle &&
      projectData.year
    ) {
      fetchBPHourAndDD();
    }
  }, [projectData.azureProjectName, projectData.monthCycle, projectData.year]);

  const handleProjectData = (val, key) => {
    setProjectData((previousData) => {
      return {
        ...previousData,
        [key]: val,
      };
    });
    setShowValidation((previousData) => {
      return {
        ...previousData,
        [`${key}Error`]: val ? false : true,
      };
    });
  };

  const clearFormFields = () => {
    setProjectData(initialProjectData);
    setShowValidation(false);
  };
  const clearFormFieldsOnAdd = () => {
    setProjectData({
      departmentName: projectData.departmentName,
      azureProjectName: "",
      monthCycle: projectData.monthCycle,
      year: new Date(2023, 0, 1),
      security: "",
      performance: "",
      bugsPerHour: "",
      defectDensity: "",
      reviewerComment: "",
    });

    setShowValidation((prev) => {
      return {
        ...prev,
        azureProjectNameError: null,
        securityError: null,
        performanceError: null,
        bugsPerHourError: null,
        defectDensityError: null,
        reviewerCommentError: null,
      };
    });
  };

  const validationHandler = () => {
    const data = Object.values(showValidation).every((item) => item === false);
    const data1 = { ...projectData };
    const data2 = { ...showValidation };

    for (const key in data1) {
      if (data1[key] === "") {
        data2[`${key}Error`] = true;
      }
    }
    setShowValidation(data2);
    return data;
  };

  const handleSubmit = async () => {
    if (validationHandler() === false) {
      return false;
    }
    try {
      const employeeName = sessionStorage.getItem("employeeName");
      const response = await axios.post(
        apiEndPoints.addQualityOfDevelopmentRecord,
        {
          departmentId: projectData.departmentName.value,
          azureProjectId: projectData.azureProjectName.value,
          year: projectData.year.getFullYear(),
          monthCycle: projectData.monthCycle.value,
          security: projectData.security.value,
          performance: projectData.performance.value,
          bugsPerHour: projectData.bugsPerHour,
          defectDensity: projectData.defectDensity,
          reviewerComment: projectData.reviewerComment,
          username: employeeName,
        }
      );
      // clearFormFields();
      clearFormFieldsOnAdd();
      // document.getElementById("exampleModalLong2").click();
      props.fetchQualityDevelopment();
      toast.success("Form submitted successfully", {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 2000,
      });
    } catch (error) {
      if (error.response && error.response.status === 409) {
        const errorMessage = error.response.data.message;
        alert(`${errorMessage}`);
      } else {
        console.error("Error submission", error);
      }
    }
  };

  return (
    <form
      className="modal fade bd-example-modal-lg"
      id="exampleModalLong2"
      tabIndex="-1"
      role="dialog"
      aria-labelledby="myLargeModalLabel"
      aria-hidden="true"
    >
      <div className="modal-dialog modal-lg" role="document">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title" id="exampleModalLongTitle">
              Quality Of Development
            </h5>
            <button
              type="button"
              className="close"
              data-dismiss="modal"
              aria-label="Close"
              onClick={() => {
                clearFormFields();
              }}
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div className="modal-body">
            <SelectList
              ErrorStyle={showValidation.departmentNameError ? "invalid" : ""}
              label="Department Name"
              id="deptName"
              placeholder="Department Name"
              value={projectData.departmentName}
              onChange={(value, e) => {
                handleProjectData(value, "departmentName");
              }}
              options={masterData.departments}
              isSearchable={true}
            />
            <SelectList
              ErrorStyle={showValidation.azureProjectNameError ? "invalid" : ""}
              label="Project Name"
              id="Project"
              placeholder="Project Name"
              value={projectData.azureProjectName}
              onChange={(value, e) => {
                handleProjectData(value, "azureProjectName");
              }}
              options={projectList}
              isSearchable={true}
            />
            <DatePickerField
              id="projYear"
              label=" Year"
              showYearPicker
              dateFormat="yyyy"
              placeholderText="Select Year"
              selected={projectData.year}
              onChange={(date) => {
                handleProjectData(date, "year");
              }}
            />
          </div>
          <div className="modal-body">
            <SelectList
              ErrorStyle={showValidation.monthCycleError ? "invalid" : ""}
              label="Quarter"
              id="Quarter"
              placeholder="Quarter"
              options={["Jan-Mar", "Apr-Jun", "July-Sep", "Oct-Dec"]}
              defaultValue={{ value: "Oct-Dec", label: "Oct-Dec" }}
              value={projectData.monthCycle}
              onChange={(value) => handleProjectData(value, "monthCycle")}
            />
            <SelectList
              ErrorStyle={showValidation.securityError ? "invalid" : ""}
              label="Security"
              id="security"
              placeholder="Security"
              options={["Yes", "No", "N/A"]}
              value={projectData.security}
              onChange={(value) => handleProjectData(value, "security")}
            />
            <SelectList
              ErrorStyle={showValidation.performanceError ? "invalid" : ""}
              label="Performance"
              id="performance"
              placeholder="Performance"
              options={["Yes", "No", "N/A"]}
              value={projectData.performance}
              onChange={(value) => handleProjectData(value, "performance")}
            />
          </div>
          <div className="modal-body">
            <TextInputField
              ErrorStyle={showValidation.bugsPerHourError ? "invalid" : ""}
              type="text"
              id="bugsPerHour"
              label="Bugs Per Hour"
              value={projectData.bugsPerHour}
              onChange={(e) => handleProjectData(e.target.value, "bugsPerHour")}
              loading={loading}
            />
            <TextInputField
              ErrorStyle={showValidation.defectDensityError ? "invalid" : ""}
              label="Defect Density"
              id="defectDensity"
              value={projectData.defectDensity}
              onChange={(e) =>
                handleProjectData(e.target.value, "defectDensity")
              }
              loading={loading}
            />
            <TextInputField
              ErrorStyle={showValidation.reviewerCommentError ? "invalid" : ""}
              label="Reviewer Comment"
              id="comment"
              rows={1}
              cols={20}
              value={projectData.reviewerComment}
              onChange={(e) =>
                handleProjectData(e.target.value, "reviewerComment")
              }
              loading={loading}
            />
          </div>
          <div className="modal-footer">
            <button
              type="button"
              onClick={handleSubmit}
              className="btn btn-success btn-Add"
            >
              Add
            </button>
            <button
              type="button"
              className="btn btn-primary"
              data-dismiss="modal"
              onClick={() => {
                clearFormFields();
              }}
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </form>
  );
};

export default FormQualityDevelopment;
